export default {
  $listener: null,
  listen: function($callback) {
    if (typeof $callback === "function")
      this.$listener = $callback;
  },
  show: function() {
    if (this.$listener != null && typeof this.$listener === "function")
      this.$listener("show")
  },
  hide: function() {
      this.$listener("hide");
  }
}



// WEBPACK FOOTER //
// ./src/assets/menu-listener.js